<!--
 * @Author:
 * @LastEditTime: 2022-04-18 16:28:29
 * @Description: 新增、编辑api
-->
<template>
  <el-dialog
    v-dialogDrag
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    title="关联模块"
    class="mini-dialog"
  >
    <el-form :model="formData" label-width="150px">
      <el-form-item label="关联模块">
        <el-select
          ref="menuTreeRef"
          value-key="Id"
          clearable
          filterable
          @clear="clearRelationModule"
          v-model="formData.relationModule"
          placeholder="请选择"
          :loading="menuTreeLoading"
        >
          <el-tree
            :props="{
              label: 'Name',
              children: '_Child',
            }"
            node-key="Id"
            highlight-current
            :data="menuTreeData"
            @node-click="menuTreeNodeClick"
            :expand-on-click-node="false"
          ></el-tree>
          <el-option
            v-for="item in flatTreeData"
            :key="item.Id"
            :value="item.Url"
            :label="item.Name"
            class="hidden"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="text-center">
        <el-button type="primary" size="small" @click="saveFormData" :loading="saveLoading"
          >确定</el-button
        >
        <el-button size="small" @click="closeDialog">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { SafetyEvaluationIndexApi } from '@wiz-api/safety-evaluation-management'

const safetyEvaluationIndexApi = new SafetyEvaluationIndexApi()

export default {
  name: 'RelationModule',
  props: {
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    operateData: {
      type: [Object, null],
    }, // 操作项数据
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      menuTreeData: [], // 菜单目录树列表数据
      flatTreeData: [], // 扁平化菜单列表数据
      menuTreeLoading: false, // 菜单目录树列表数据加载loading
      formData: {
        relationModule: null, // 关联模块
      },
      saveLoading: false, // 保存按钮loading
    }
  },
  methods: {
    /**
     * @description 获取菜单目录树
     */
    async getMenuTree() {
      if (!window.__POWERED_BY_QIANKUN__) return
      const formData = new FormData()
      formData.append('TableName', 'Sys_Menu')
      formData.append('_PageIndex', 1)
      formData.append('_PageSize', 999)
      const instance = axios.create()
      instance.defaults.baseURL = localStorage.getItem('DiyApiBase')
      const token = localStorage.getItem('authorization')
      instance.defaults.headers.common.Authorization = `Bearer ${token}`
      this.menuTreeLoading = true
      const res = await instance.post('/api/diytable/getDiyTableRowTree', formData)
      if (res.status === 200 && res.data?.Code === 1) {
        this.menuTreeData = res.data.Data
        this.flatTreeData = this.transformList([...res.data.Data])
      }
      this.menuTreeLoading = false
    },

    /**
     * @description 清空关联模块筛选
     */
    clearRelationModule() {
      this.formData.relationModule = null
    },

    /**
     * @description 关联模块目录树下拉框点选
     */
    menuTreeNodeClick(node) {
      if (node._Child) return
      this.formData.relationModule = node.Url
      this.$refs.menuTreeRef.blur()
    },

    /**
     * @description 菜单目录树数据扁平化
     */
    transformList(data, resultList = []) {
      if (!Array.isArray(data)) {
        return []
      }
      data.forEach((node) => {
        resultList.push({ ...node })
        this.transformList(node._Child, resultList)
      })
      return resultList
    },

    /**
     * @description 关闭弹窗
     */
    closeDialog() {
      this.dialogVisible = false
    },

    /**
     * @description 保存
     */
    async saveFormData() {
      if (!this.formData.relationModule) {
        this.$message.warning('请先选择关联模块')
        return
      }
      this.saveLoading = true
      const [err, res] = await safetyEvaluationIndexApi.updateModule({
        id: this.operateData.safetyEvaluationIndexId,
        relationModule: this.formData.relationModule,
      })
      this.saveLoading = false
      if (res) {
        this.$message.success('成功')
        this.$emit('refreshList')
        this.closeDialog()
      }
    },
  },

  async created() {
    await this.getMenuTree()
    this.formData.relationModule = this.operateData?.relationModule
  },
}
</script>

<style scoped lang="scss">
::v-deep .ql-container {
  height: 400px !important;
}
</style>
